import styled from 'styled-components';

export const Panel = styled.div`
  background: #fff;
  margin-top: 24px;
`;

export const SectionTitle = styled.div`
  margin-top: 24px;
  margin-bottom: 8px;
  font-weight: 700;
  color: #000;
  font-size: 14px;
  font-family: var(--bombas-font), sans-serif;
`;

export const DetailsList = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #EAEADF;
  border-radius: 4px;
  padding: 12px 16px;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #EAEADF;

  &:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: none;
  }
`;

export const DetailLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DetailLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-family: var(--bombas-font), sans-serif;
  color: #000;
  margin: 0;
  letter-spacing: 0.25px;
`;

export const DetailMeta = styled.p`
  font-size: 12px;
  font-family: var(--bombas-font), sans-serif;
  color: ${({ $danger }) => ($danger ? '#DC2626' : '#5C5851')};
  margin: 0;
`;

export const DetailRight = styled.p`
  font-weight: 800;
  font-size: 18px;
  font-family: var(--bombas-font), sans-serif;
  color: #5C5851;
  margin: 0;
`;

export const Footnote = styled.p`
  margin: 16px 0 0 0;
  font-size: 14px;
  font-family: var(--bombas-font), sans-serif;
  color: #5C5851;
  letter-spacing: 0.25px;
`;

export const EmptyState = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
  padding: 12px;
  text-align: center;
  color: #000;
  font-size: 14px;
  font-family: var(--bombas-font), sans-serif;
  border: 1px solid #EAEADF;
  border-radius: 4px;
  letter-spacing: 0.25px;
  margin: 0;
`;

export default {};
